import { Component, Input } from '@angular/core';
import { SolrSearchResult } from '../../../../../core/model';
import { ItemListType } from '../../../../../features/tracking/events/tracking-events';
import { SearchResultsContentBaseComponent } from '../search-results-content-base/search-results-content-base.component';

@Component({
  selector: 'py-search-results-content-primary',
  templateUrl: './search-results-content-primary.component.html',
  styleUrls: ['./search-results-content-primary.component.scss'],
  standalone: false,
})
export class SearchResultsContentPrimaryComponent extends SearchResultsContentBaseComponent {
  @Input() searchResults: SolrSearchResult;

  itemListTypeSearchPrimary = ItemListType.SEARCH;

  constructor() {
    super();
  }
}
